import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Assets/img/logo.svg";
import Dropdown from "react-bootstrap/Dropdown";

function MobileMenuModal() {
  return (
    <>
      <button
        className="offcanvas-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasExample"
        aria-controls="offcanvasExample"
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </button>

      <div
        className="offcanvas offcanvas-start"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <div className="offcanvas-logo">
            <Link to="/">
              <img src={Logo} alt="#" />
            </Link>
          </div>
          <button
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fi-rr-cross"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="offcanvas-menu">
            <ul className="list-none offcanvas-menu-list">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/aboutus">About</NavLink>
              </li>
              <li>
                <NavLink to="/whystudy">Why study</NavLink>
              </li>
              <li>
                <NavLink to="/facilities">Facilities</NavLink>
              </li>
              <li>
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Admission<i className="fi-rr-angle-small-down"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mobile-menu-dropdown">
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/applyadmission">Apply admission</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/admissionguideline">
                        Addmission guideline
                      </NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/admissionform">Admission form</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/admissionsuspension">
                        Admission suspension
                      </NavLink>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              <li>
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Academic curriculum
                    <i className="fi-rr-angle-small-down"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mobile-menu-dropdown">
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/academicfees">Academic fees</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/classbook">Class book</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/classroutine">Class routine</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/examroutine">Exam routine</NavLink>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              <li>
                <NavLink to="/noticeboard">Notice board</NavLink>
              </li>
              <li>
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    More
                    <i className="fi-rr-angle-small-down"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mobile-menu-dropdown">
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/studentresults">Student results</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/blog">Blog/Events</NavLink>
                    </Dropdown.Item>
                    <Dropdown.Item className="mobile-menu-dropdown-list">
                      <NavLink to="/contactus">Contact us</NavLink>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>
            <div className="offcanvas-social">
              <h4 className="follow-title">Follow Us:</h4>
              <ul className="list-none">
                <li>
                  <a href="https://twitter.com" target="_blank">
                    <i className="icofont-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://facebook.com" target="_blank">
                    <i className="icofont-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com" target="_blank">
                    <i className="icofont-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://linkedin.com" target="_blank">
                    <i className="icofont-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileMenuModal;
